import { Fragment } from "react";
import images from "../../../utilities/images/images";
import "./FooterPage.css";
import { connect } from "react-redux";
import uiActions from "../../../redux/ui/action";

const FooterPage = () => {
  const handlePhoneClick = () => {
    window.location.href = "tel:18002121799";
  };

  const handleEmailClick = () => {
    window.location.href = "mailto:info@motioniitjee.com";
  };

  return (
    <Fragment>
      <footer id="footer">
        <div className="sec7-wrapper">
          <div className="logo">
            <img src={images.m2_logo} alt="logo" />
          </div>

          <div className="about_contact" style={{ display: "flex" }}>
            <div className="a_link" onClick={handlePhoneClick}>
              <i className="fas fa-phone-volume phn"></i>
              <span style={{ color: "#fff" }}>18002121799</span>
            </div>
            <div className="a_link" onClick={handleEmailClick}>
              <i className="fas fa-envelope"></i>
              <span style={{ color: "#fff" }}>info@motioniitjee.com</span>
            </div>
          </div>
        </div>
        <div className="copyright" style={{ color: "#fff" }}>
          Copyright © 2019-2025 motion. All rights reserved.
        </div>
      </footer>

      <footer id="mobile-footer">
        <div className="container-mobile">
          <div className="logo">
            <img src={images.m2_logo} alt="Motion logo" />
          </div>
          <div className="footer-content">
            <div className="get-in-touch">
              <div onClick={handlePhoneClick}>
                <i
                  className="fas fa-phone-volume"
                  style={{ color: "#fff" }}
                ></i>
                <span style={{ color: "#fff" }}>18002121799</span>
              </div>
              <div onClick={handleEmailClick}>
                <i className="fas fa-envelope" style={{ color: "#fff" }}></i>
                <span style={{ color: "#fff" }}>info@motioniitjee.com</span>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </Fragment>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    startLoading: () => {
      dispatch(uiActions.startLoading());
    },
    finishLoading: () => {
      dispatch(uiActions.finishLoading());
    },
  };
};

export default connect(null, mapDispatchToProps)(FooterPage);
